import featureConfig from '../../features.json';
import moment from 'moment';

export const isHomePageBannerActive = () => moment().isBetween(featureConfig.homepageBanner.validFrom, featureConfig.homepageBanner.validTo)